export const stackedBarChartOptions = {
  series: [
    {
      type: 'bar',
    },
  ],
};
